import {
  isEmpty,
  isEqual,
  noop,
  uuCompactArrayOrObject,
} from 'lodash';
import { mapFormValuesToWrapperFormat } from './paymentsInsuranceValueMapping';

const getComparableInsuranceValues = (insurance = {}) => mapFormValuesToWrapperFormat(insurance);

export default function createUpdateDeletePaymentsInsurances ({
  initialPaymentsIds = [],
  values = {},
  contactId,
  groupId,
  createInsuranceEntry = noop,
  editInsuranceEntry = noop,
  deleteInsuranceEntry = noop,
  showNotification = true,
}) {
  const currentPaymentsIds = values.insurance.map((insurance) => insurance.id);
  const currentPaymentsIdSet = new Set(currentPaymentsIds);
  // creates payments insurance object for editing insurance ID lookup
  const currentPaymentsObject = values.insurance.reduce((idsMap, insurance) => (
    { ...idsMap, [insurance.id]: insurance }), {});
  const initialPaymentsObject = initialPaymentsIds.reduce((idsMap, insurance) => (
    { ...idsMap, [insurance.id]: insurance }), {});

  // identifies insurances for delete, add, edit
  const deletedIds = initialPaymentsIds.filter(({ id }) => !currentPaymentsIdSet.has(id));
  const editedInsuranceIds = initialPaymentsIds.filter(({ id }) => (
    currentPaymentsIdSet.has(id) && !isEqual(
      getComparableInsuranceValues(initialPaymentsObject[id]),
      getComparableInsuranceValues(currentPaymentsObject[id]),
    )
  ));
  const isNewInsurance = (insurance) => isEmpty(insurance.id) && !isEmpty(insurance.plan);
  const addedInsurances = values.insurance.filter((insurance) => isNewInsurance(insurance));

  // Delete Insurances
  if (!isEmpty(deletedIds)) {
    deletedIds.map(({ id }) => deleteInsuranceEntry(id, contactId, groupId, showNotification));
  }

  // Add New Insurances
  if (!isEmpty(addedInsurances)) {
    addedInsurances.map((insurance) => {
      const compactInsuranceValues = uuCompactArrayOrObject(insurance);
      return createInsuranceEntry({
        contactId,
        groupId,
        values: { insurance: compactInsuranceValues },
        type: 'new',
        showNotification,
      });
    });
  }

  // Edit Current Insurances
  if (!isEmpty(editedInsuranceIds)) {
    editedInsuranceIds.map(({ id: insuranceId }) => {
      const compactInsuranceValues = uuCompactArrayOrObject(currentPaymentsObject[insuranceId]);
      return editInsuranceEntry({
        contactId,
        groupId,
        values: { insurance: compactInsuranceValues },
        insuranceId,
        showNotification,
      });
    });
  }
}
